import { AclCellState } from './types';

export type AclExplanationKind =
  | AclCellState
  | 'partial'
  | 'scope_changed'
  | 'awaiting_resnapshot';

interface AclExplanationCopy {
  label: string;
  description: string;
  buttonLabel: string;
}

export const ACL_EXPLANATION_COPY: Record<AclExplanationKind, AclExplanationCopy> = {
  visible: {
    label: 'Visible value',
    description: 'This value is available under the current access policy.',
    buttonLabel: 'Explain visible ACL value',
  },
  redacted: {
    label: 'Restricted',
    description: 'Restricted by access policy. The hidden value is not used for display, sorting, charts, exports, or diagnostics.',
    buttonLabel: 'Explain restricted value',
  },
  unavailable: {
    label: 'Unavailable',
    description: 'Policy is unavailable for this value. Refresh after access is restored; no hidden value is shown.',
    buttonLabel: 'Explain unavailable value',
  },
  partial: {
    label: 'Partial view',
    description: 'Only allowed accounts are included. Denied account identifiers and precise denied counts are not shown.',
    buttonLabel: 'Explain partial coverage',
  },
  scope_changed: {
    label: 'Scope changed',
    description: 'Access scope changed. A fresh ACL-safe snapshot is required before values are shown.',
    buttonLabel: 'Explain ACL scope change',
  },
  awaiting_resnapshot: {
    label: 'Resnapshot required',
    description: 'Waiting for a fresh ACL-safe snapshot. Stale replay values are not displayed.',
    buttonLabel: 'Explain resnapshot requirement',
  },
};

